module.exports = __webpack_public_path__ + "static/config-banner-show-on-home-9d874b18629d5d43475630c7c360ef09.jpg";